module.exports = __webpack_public_path__ + "img/Skirt-Front-B8-Db-Ha-Ia.c5e1f2fb.png";